module.exports = __webpack_public_path__ + "static/media/logoWhite.049812df.svg";